import { FirebaseApp, initializeApp } from "firebase/app";
import { Auth, getAuth } from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";

// Firebase configuration using Vite environment variables
const firebaseConfigString = import.meta.env.VITE_FIREBASE_CONFIG;

if (!firebaseConfigString) {
  console.error(
    "Firebase config error: VITE_FIREBASE_CONFIG is not defined. Please ensure it is set in your .env file or environment variables.",
  );
  throw new Error(
    "VITE_FIREBASE_CONFIG is not defined. Please set it in your .env file.",
  );
}

let firebaseConfig;
try {
  firebaseConfig = JSON.parse(firebaseConfigString);
} catch (error) {
  console.error(
    "Firebase config error: Failed to parse VITE_FIREBASE_CONFIG. Ensure it's valid JSON.",
    error,
  );
  throw new Error(
    "Failed to parse VITE_FIREBASE_CONFIG. Please ensure it's valid JSON.",
  );
}

// Basic check for essential config properties
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error(
    "Firebase config error: VITE_FIREBASE_CONFIG is missing essential properties like apiKey or projectId.",
    firebaseConfig,
  );
  throw new Error(
    "VITE_FIREBASE_CONFIG is missing essential properties like apiKey or projectId.",
  );
}

export const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app); // using (default) db on each stand
export const agentDb: Firestore = getFirestore(app, "agent-data");
